import Image from "next/image";
import { cn } from "@/lib/utils";

interface PandaLogoProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
}

// `className` controls the rendered size. `px` is the optimizer hint passed
// to next/image — kept intentionally large so the square crop of the wide
// lockup (1168×398) still has enough source pixels to stay sharp on retina.
const sizes: Record<string, { className: string; px: number }> = {
  xs: { className: "h-6 w-6", px: 192 },
  sm: { className: "h-9 w-9", px: 256 },
  md: { className: "h-11 w-11", px: 320 },
  lg: { className: "h-16 w-16", px: 448 },
  xl: { className: "h-24 w-24", px: 640 },
};

export function PandaLogo({ size = "sm", className }: PandaLogoProps) {
  const s = sizes[size];
  return (
    <Image
      src="/panda-lockup.png"
      alt="Panda"
      width={s.px}
      height={s.px}
      quality={95}
      className={cn(
        "aspect-square shrink-0 object-cover object-left",
        s.className,
        className,
      )}
      priority
    />
  );
}

export function PandaEmoji({ className }: { className?: string }) {
  return (
    <span
      className={cn("select-none", className)}
      role="img"
      aria-label="panda"
    >
      🐼
    </span>
  );
}

interface PandaLockupProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
}

const lockupSizes: Record<string, string> = {
  xs: "h-5 w-auto",
  sm: "h-7 w-auto",
  md: "h-9 w-auto",
  lg: "h-12 w-auto",
  xl: "h-16 w-auto",
};

export function PandaLockup({ size = "md", className }: PandaLockupProps) {
  return (
    <Image
      src="/panda-lockup.png"
      alt="Panda"
      width={1168}
      height={398}
      className={cn("shrink-0 object-contain", lockupSizes[size], className)}
      priority
    />
  );
}
